import { Link } from "react-router-dom";
import { MapPin, Navigation, Phone } from "lucide-react";
import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { LOCATIONS, BRAND } from "../data/content";
import { usePageMeta } from "../hooks/use-page-meta";
import { track } from "../lib/tracking";

export default function Locations() {
  usePageMeta(
    "Service Locations | Celebrity Bouncers — AP & Telangana",
    "Event security and VIP support across Vijayawada, Guntur, Amaravati, Hyderabad, Visakhapatnam, Tirupati and other AP & Telangana locations on request."
  );
  return (
    <>
      <PageHero
        testid="locations-page-hero"
        eyebrow="Service Locations"
        title="Wherever the Occasion Takes You"
        description="Coordinated from our Vijayawada office, our teams serve events across Andhra Pradesh and Telangana."
      />
      <section className="container-x py-20 sm:py-28" data-testid="locations-page-grid">
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {LOCATIONS.map((l, i) => (
            <Reveal key={l.city} delay={(i % 3) * 0.07}>
              <div
                data-testid={`location-card-${l.city.toLowerCase()}`}
                className="group flex h-full flex-col border border-white/[0.07] bg-navy/50 p-8 transition-all duration-500 hover:border-gold/40"
              >
                <MapPin size={20} className="text-gold" />
                <div className="mt-5 flex items-center gap-3">
                  <h2 className="font-serif text-2xl font-medium text-ivory">{l.city}</h2>
                  {l.primary && (
                    <span className="border border-gold/30 px-2 py-0.5 text-[9px] font-semibold uppercase tracking-[0.2em] text-gold">
                      HQ
                    </span>
                  )}
                </div>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-steel">{l.note}</p>
                <Link
                  to="/contact"
                  data-testid={`location-enquire-${l.city.toLowerCase()}`}
                  className="mt-6 text-[11px] font-semibold uppercase tracking-[0.22em] text-gold/80 transition-colors duration-300 hover:text-gold"
                >
                  Plan an event here
                </Link>
              </div>
            </Reveal>
          ))}
        </div>
        <Reveal className="mt-12">
          <div className="border border-gold/20 bg-navy/40 p-8 sm:p-10">
            <h2 className="font-serif text-2xl font-medium text-ivory sm:text-3xl">
              Other AP & Telangana Locations
            </h2>
            <p className="mt-4 max-w-2xl text-sm leading-relaxed text-steel sm:text-base">
              Events in other cities and towns across the two states can be supported on request.
              Share your venue and dates, and we will confirm coverage honestly.
            </p>
            <div className="mt-8 flex flex-wrap gap-4">
              <a
                href={BRAND.directions}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="locations-directions-btn"
                onClick={() => track("directions_click", { placement: "locations_page" })}
                className="flex items-center gap-2 bg-gold px-6 py-3.5 text-[12px] font-bold uppercase tracking-[0.2em] text-obsidian transition-colors duration-300 hover:bg-gold-soft"
              >
                <Navigation size={15} /> Directions to Our Office
              </a>
              <a
                href={BRAND.phonePrimaryHref}
                data-testid="locations-call-btn"
                onClick={() => track("call_click", { placement: "locations_page" })}
                className="flex items-center gap-2 border border-ivory/25 px-6 py-3.5 text-[12px] font-bold uppercase tracking-[0.2em] text-ivory transition-colors duration-300 hover:border-gold hover:text-gold"
              >
                <Phone size={15} /> {BRAND.phonePrimary}
              </a>
            </div>
          </div>
        </Reveal>
      </section>
    </>
  );
}
